class TeamCalendarListController {

  isEmptyList(teamCalendarList = []) {
    return teamCalendarList.length === 0;
  }

}

export default TeamCalendarListController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendarMobile/teamCalendarList/teamCalendarList.controller.js